import { Component, Input, OnChanges, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LargeLoanProgramName, ProductCode } from 'common';
import { OfferNavigator } from '../../calculator/offer-navigator';
import { OfferBundleData } from '../offer-bundle.service';

@Component({
    selector: 'ifa-product-navigator',
    templateUrl: './product-navigator.component.html',
    styleUrls: ['./product-navigator.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class ProductNavigatorComponent implements OnChanges {

  @Input() offerNavigator: OfferNavigator;
  @Input() customerView: boolean;

  readonly largeLoanProgramName = LargeLoanProgramName;

  locOfferBundle: OfferBundleData;
  largeLoanProgramOfferBundle: OfferBundleData;
  termOfferBundle: OfferBundleData;
  lawOfferBundle: OfferBundleData;

  isCurrentLocProduct: boolean;
  isCurrentLargeLoanProgramProduct: boolean;
  isCurrentTermProduct: boolean;
  isCurrentLawProduct: boolean;

  constructor(private _router: Router, private _route: ActivatedRoute) { }

  // The navigator is rebuilt whenever the application or the selected offer changes.
  ngOnChanges(): void {
    const currentOfferBundle = this.offerNavigator?.currentOfferBundle;
    const currentProduct = currentOfferBundle?.productCode;

    this.locOfferBundle = this.offerNavigator?.bestLocOfferBundle;
    this.largeLoanProgramOfferBundle = this.offerNavigator?.bestLargeLoanProgramOfferBundle;
    this.termOfferBundle = this.offerNavigator?.bestTermOfferBundle;
    this.lawOfferBundle = this.offerNavigator?.bestLawOfferBundle;

    this.isCurrentLocProduct = currentProduct === ProductCode.LOC && !currentOfferBundle.largeLoanProgram;
    this.isCurrentLargeLoanProgramProduct = currentProduct === ProductCode.LOC && currentOfferBundle.largeLoanProgram;
    this.isCurrentTermProduct = currentProduct === ProductCode.Term;
    this.isCurrentLawProduct = currentProduct === ProductCode.Law;
  }

  click(offerBundle: OfferBundleData) {
    let path = offerBundle.productCode.toLowerCase();

    let uuid = this._route.snapshot.queryParamMap.get('uuid');

    let pathMode = this.customerView ? 'preview' : 'calculator';

    this._router.navigate([`/${pathMode}/${path}`], { queryParams: { uuid: uuid, bundleId: offerBundle.bundleId } });
  }
}
